module.exports = __webpack_public_path__ + "static/baloon-64e28077f52a85485c38045265363fbd.svg";